import React from "react";
import Totalquantityanddutyinbondexbondreport from "./totalquantityanddutyinbondexbondreport";
import Totalquantityanddutyinbondexbondmaterialwisereport from "./totalquantityanddutyinbondexbondmaterialwisereport";
import Balancedutypendingtopayinexbondreport from "./balancedutypendingtopayinexbondreport";
import Balancedutypendingtopayindispatchreport from "./balancedutypendingtopayindispatchreport";
import Dutypendingtopayinexbondreport from "./dutypendingtopayinexbondreport";

export default function Dashboardview() {
  return (
    <div className="flex flex-col gap-8">
      {/* ===== Dashboard Header ===== */}
      <div className="flex items-center justify-end">
        <div className="px-2">
          <h1 className="text-lg font-bold text-gray-900 flex items-center gap-2">
            <span className="inline-block w-1.5 h-6 bg-primary rounded-full"></span>
            Reports
          </h1>
        </div>
      </div>

      <div className="flex flex-col xl:flex-row gap-8">
        <Totalquantityanddutyinbondexbondreport />
        <Dutypendingtopayinexbondreport />
      </div>
      <div className="flex flex-col xl:flex-row gap-8 items-start">
        <Balancedutypendingtopayinexbondreport />
        <Balancedutypendingtopayindispatchreport />
      </div>
      <Totalquantityanddutyinbondexbondmaterialwisereport />
    </div>
  );
}



